if (!customElements.get('swiper-image-gallery')) {
  class Gallery extends HTMLElement {
    constructor() {
      super();
      this.startingIndex = this.dataset.startingIndex;
      this.slideCount = this.dataset.slideCount;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.gallery = this.querySelector('[data-gallery]');

      this.querySelector('[data-pagination]').innerHTML = `${(Number(this.startingIndex) + 1)} / ${this.slideCount}`;

      const updateA11y = (index) => {
        const slides = this.gallery.querySelectorAll('swiper-slide');
        if (!slides.length) return;
        const i = typeof index === 'number' ? index : ((this.gallery.swiper?.realIndex ?? Number(this.startingIndex)) || 0);
        slides.forEach((s, idx) => s.setAttribute('aria-hidden', idx === i ? 'false' : 'true'));
      };

      setTimeout(() => updateA11y(), 0);

      this.gallery.addEventListener('swiperslidechangetransitionend', (e) => {
        setTimeout(() => {
          this.querySelector('[data-pagination]').innerHTML = `${(e.detail[0]?.realIndex + 1)} / ${this.slideCount}`;
          updateA11y(e.detail[0]?.realIndex);
        }, 10);
      });
      this.gallery.addEventListener('click', () => this.gallery.swiper.zoom.toggle());
    }
  }
  
  customElements.define('swiper-image-gallery', Gallery);
}